import React from 'react';

interface DefaultErrorDescriptionProps {
    errorDescription: string;
}

function DefaultErrorDescription({ errorDescription }: DefaultErrorDescriptionProps): React.JSX.Element {
    return <p className="text-foreground text-base leading-relaxed">{errorDescription}</p>;
}

export default DefaultErrorDescription;
